import { memo, useEffect, useState } from 'react'
import _ from 'lodash'
import { ALL_ORGS_SELECTED, DevicesColumnKeys } from 'lib/constants'
import {
  ActionButton,
  AddDeviceQRC,
  ViewWrapper,
  PageWrapper,
  ViewSpacerWrapper,
  StyledHeader,
} from 'components/widgets'
import { DetailsDrawer, Modal } from 'models'
import { isAdmin, isInstaller, isSuperAdmin } from 'lib/utils/auth'
import * as utils from './utils'
import { PreConfiguredTableView } from 'components/partials/TableViewV2'
import { SortOrder, TableToolEvent, Device, TranslationGroup, trans, TranslationKey } from 'lib/types'
import { getDeviceTooltip, invertBinaryEnum } from 'lib/utils/common'
import { DeviceDetailDrawer } from 'components/partials/DrawerDetails/DeviceDetailDrawer'
import { useHistory, useParams } from 'react-router-dom'
import { DEVICES_PATH, RESPONDERS_PATH } from 'lib/constants'
import { useQuery } from 'models/modelUtils'
import { RenderCounter } from 'components/widgets/RenderCounter'
import { useGlobal } from 'contexts/GlobalProvider'
import { useDevices } from 'contexts/DevicesProvider'
import { getRequestV5 } from 'models/api/rest'
import { getVoiceLicenses, VoiceLicenses } from 'models/api/licenses'
import { VoiceLicensedUsers } from './Partials'
import { voiceColumnFlag } from 'lib/utils/featureFlags'
import isNil from 'lodash/isNil'

interface AlertSourcesViewProps {
  responders?: boolean
}
interface RouteParams {
  id: string
}

export const AlertSourcesView = memo(({ responders = false }: AlertSourcesViewProps) => {
  const history = useHistory()
  const { id } = useParams<RouteParams>()
  const query = useQuery()
  // const showPresence = false //isTruthy(useSearchParams('presence') as string)
  // const selectedOrgId = NavState.use(({ selectedOrgId }) => selectedOrgId)
  // const selectedOrg = Orgs.useSelectedOrg()

  const common: TranslationGroup = trans.common()
  const { selectedOrgId, selectedOrg } = useGlobal()
  const { devices, setDevices, tableState, setTableState, pagination, setPagination, loading, setLoading } =
    useDevices()

  const {
    setModalContent,
    openModal: openQrcModal,
    closeModal,
  } = Modal.useStaticModal(`${common.register_qr} ${selectedOrg && selectedOrg.name}`)
  const baseRoute = responders ? RESPONDERS_PATH : DEVICES_PATH

  const [voiceLicenses, setVoiceLicenses] = useState<VoiceLicenses | undefined>(undefined)
  useEffect(() => {
    if (!voiceColumnFlag || !selectedOrgId) return
    let alive = true
    setVoiceLicenses(undefined)
    getVoiceLicenses(selectedOrgId)
      .then(licenses => alive && setVoiceLicenses(licenses))
      .catch(e => console.error('Failed to load voice licenses:', e))
    return () => {
      alive = false
    }
  }, [selectedOrgId])

  useEffect(() => {
    setModalContent(<AddDeviceQRC responders={responders} closeModal={closeModal} />)
  }, [responders, closeModal, setModalContent])

  function handleDrawerClose() {
    history.push({
      pathname: `${baseRoute}`,
      search: query.toString(),
    })
    DetailsDrawer.close()
  }

  function handleRowClick(row: Device) {
    if (row.id != id) {
      history.push({
        pathname: `${baseRoute}/${row.id}`,
        search: query.toString(),
      })
    }
    DetailsDrawer.show({
      drawerComponent: DeviceDetailDrawer,
      drawerProps: {
        device: row,
        close: handleDrawerClose,
      },
    })
  }

  function handleHeaderClick(header: string) {
    console.log({ header })
    // I will need to ignore certain header clicks as sorting is missing for some columns
    const excludeList: string[] = [DevicesColumnKeys.ButtonConnected, DevicesColumnKeys.Voice]
    if (excludeList.includes(header)) return

    setLoading(true)
    getRequestV5({
      endpoint: '/alert_sources',
      headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
      params: {
        filterBy:
          tableState.filterBy != utils.getFilterOptions()[0] // not all beacons
            ? { field: 'deviceType', value: tableState.filterBy }
            : undefined,
        searchBy: { value: tableState.searchBy },
        sortBy: {
          field: header,
          order: tableState.sortBy.order === SortOrder.Ascending ? SortOrder.Descending : SortOrder.Ascending,
        },
      },
    }).then(response => {
      const data = response.data
      setDevices(data.data)
      setPagination(data.meta)
      setLoading(false)
      // setTableTools({ ...tableTools, pagination: data.meta })
    })
    setTableState(state => {
      return Object.assign({}, state, {
        sortBy: {
          field: header,
          order: state.sortBy.field === header ? invertBinaryEnum(state.sortBy.order) : SortOrder.Ascending,
        },
      })
    })
  }

  function handleToolEvent(toolEvent: TableToolEvent<string, DevicesColumnKeys>) {
    console.log({ toolEvent })
    if (toolEvent.filterByRequest) {
      setLoading(true)
      getRequestV5({
        endpoint: '/alert_sources',
        headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
        params: {
          filterBy:
            toolEvent.filterByRequest != utils.getFilterOptions()[0] // not all beacons
              ? { field: 'deviceType', value: toolEvent.filterByRequest }
              : undefined,
          searchBy: { value: tableState.searchBy },
        },
      }).then(response => {
        const data = response.data
        setDevices(data.data)
        setPagination(data.meta)
        setLoading(false)
      })
    } else if (toolEvent.searchByRequest || toolEvent.searchByRequest == '') {
      setLoading(true)
      getRequestV5({
        endpoint: '/alert_sources',
        headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
        params: {
          filterBy:
            tableState.filterBy != utils.getFilterOptions()[0] // not all beacons
              ? { field: 'deviceType', value: tableState.filterBy }
              : undefined,
          searchBy: { value: toolEvent.searchByRequest },
        },
      }).then(response => {
        const data = response.data
        setDevices(data.data)
        setPagination(data.meta)
        setLoading(false)
        // setTableTools({ ...tableTools, pagination: data.meta })
      })
    } else if (toolEvent.sortByRequest) {
      console.log('so', toolEvent.sortByRequest)

      setLoading(true)
      getRequestV5({
        endpoint: '/alert_sources',
        headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
        params: {
          filterBy:
            tableState.filterBy != utils.getFilterOptions()[0] // not all beacons
              ? { field: 'deviceType', value: tableState.filterBy }
              : undefined,
          searchBy: { value: tableState.searchBy },
          sortBy: { field: toolEvent.sortByRequest.field, order: toolEvent.sortByRequest.order },
        },
      }).then(response => {
        const data = response.data
        setDevices(data.data)
        setPagination(data.meta)
        setLoading(false)
        // setTableTools({ ...tableTools, pagination: data.meta })
      })
    }

    // set table state after tool event
    setTableState(state => ({
      filterBy: toolEvent.filterByRequest || state.filterBy,
      sortBy: toolEvent.sortByRequest || state.sortBy,
      searchBy: isNil(toolEvent.searchByRequest) ? state.searchBy : toolEvent.searchByRequest,
    }))
  }

  function handlePageChange(page: any, newPage: any) {
    setLoading(true)
    getRequestV5({
      endpoint: '/alert_sources',
      headers: selectedOrgId && selectedOrgId != ALL_ORGS_SELECTED ? { org_id: selectedOrgId } : {},
      params: {
        pagination: { currentPage: newPage },
        filterBy:
          tableState.filterBy != utils.getFilterOptions()[0] // all beacons selected in filter?
            ? { field: 'deviceType', value: tableState.filterBy }
            : undefined,
        searchBy: { value: tableState.searchBy },
        sortBy: {
          field: tableState.sortBy.field,
          order: tableState.sortBy.order,
        },
      },
    }).then(response => {
      const data = response.data
      setDevices(data.data)
      setPagination(data.meta)
      setLoading(false)
    })
  }

  const isAdminOrInstaller = isAdmin(selectedOrgId) || isInstaller(selectedOrgId) || isSuperAdmin()
  const translation: TranslationGroup = trans.group(TranslationKey.DEVICES_TABLE_VIEW)

  return (
    <>
      <PageWrapper>
        <ViewWrapper>
          <RenderCounter name={'AlertSourcesView'} />
          <ViewSpacerWrapper>
            {responders && <StyledHeader>{common.responder_devices}</StyledHeader>}
            <PreConfiguredTableView
              sortedData={devices}
              tableState={tableState}
              columnConfigs={utils.getColumnConfigs(voiceLicenses?.alertSourceIds)}
              filterOptions={utils.getFilterOptions()}
              sortOptions={utils.getSortOptions()}
              getRowToolTip={getDeviceTooltip}
              onHeaderClick={handleHeaderClick}
              onRowClick={handleRowClick}
              onToolEvent={handleToolEvent}
              selectedRowId={id}
              loading={loading}
              pagination={pagination}
              onPageChange={handlePageChange}
              hiddenColumns={
                responders
                  ? [
                      DevicesColumnKeys.Type,
                      DevicesColumnKeys.Battery,
                      DevicesColumnKeys.Firmware,
                      DevicesColumnKeys.RSSI,
                    ]
                  : undefined
              }
            >
              <ActionButton onClick={() => utils.handleDownloadCSV(selectedOrgId || '')}>
                {common.download_csv}
              </ActionButton>
              {isAdminOrInstaller && (
                <ActionButton
                  onClick={() => {
                    if (selectedOrgId === ALL_ORGS_SELECTED) alert(translation.register_select_org)
                    else openQrcModal()
                  }}
                >
                  {common.register} {responders ? common.responders : common.devices}
                </ActionButton>
              )}
            </PreConfiguredTableView>
            {voiceColumnFlag && !responders && (
              <VoiceLicensedUsers
                users={voiceLicenses?.users}
                title={translation.voice_licensed_users}
                info={translation.voice_licensed_users_info}
                emptyText={translation.voice_licensed_users_none}
                loadingText={common.loading}
              />
            )}
          </ViewSpacerWrapper>
        </ViewWrapper>
      </PageWrapper>
    </>
  )
})
AlertSourcesView.displayName = 'AlertSourcesView'
